import React from "react";
import { Link } from "react-router-dom";
import { PageHero } from "./About";
import { ArrowRight } from "lucide-react";
import { centres } from "./COEDetail";

const CentreOfExcellence = () => (
  <main>
    <PageHero
      title="Centre of Excellence"
      sub="Industry-linked learning spaces and training platforms"
      image="https://images.pexels.com/photos/3862132/pexels-photo-3862132.jpeg?w=2400"
    />

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="grid md:grid-cols-2 gap-6">
        {centres.map((centre) => (
          <Link
            key={centre.id}
            to={`/coe/${centre.id}`}
            className="bg-white border border-brand/15 p-6 card-hover block"
          >
            <span className="text-xs tracking-[0.18em] text-brand font-sans-ui font-semibold uppercase">
              {centre.department}
            </span>
            <h2
              className="text-2xl text-brand font-semibold mt-2"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {centre.name}
            </h2>
            <p className="text-sm text-[#2a2a2a]/85 leading-relaxed mt-3">
              {centre.summary}
            </p>
            <span className="inline-flex items-center gap-1 text-brand hover:underline mt-5 text-sm font-sans-ui">
              View Centre <ArrowRight size={14} />
            </span>
          </Link>
        ))}
      </div>
    </section>
  </main>
);

export default CentreOfExcellence;
